const typographyFormServiceQuesList = {
  itensVerifLabel: 'CHECKLIST VERIFICATION ITEMS'
};

export default typographyFormServiceQuesList;
